import React, { useState } from "react";
import { deepEquals } from "../utils/deep-equals";

export interface IRequestCache {
    api: string,
    parameters: Record<string, any>,
    response: any
}

export interface IGlobalCache {
    cacheRequest: (api: string, parameters: Record<string, any>, response: any) => void;
    setStorageItem: (key: string, value: any) => void;
    getStorageItem: (key: string) => any;
    getCachedRequest: (api: string, parameters: Record<string, any>) => any;
}

export function useGlobalCache(): IGlobalCache {
    const [requestStorage, setRequestStorage] = useState<IRequestCache[]>([]);
    const [storage, setStorage] = useState<Record<string, any>>({});

    const cacheRequest = (api: string, parameters: Record<string, any>, response: any) => {
        setRequestStorage((prevState) => {
            const updatedState = [...prevState];
            //перепишем значение если такое уже существует
            const cachedValueIndex = requestStorage.findIndex(r => r.api === api && deepEquals(r.parameters, parameters));
            if (cachedValueIndex >= 0) {
                updatedState.splice(cachedValueIndex, 1, response);
            } else {
                updatedState.push({
                    api, parameters, response
                });
            }

            return updatedState;
        });
    };

    const getCachedRequest = (api: string, parameters: Record<string, any>) => {
        const cachedValue = requestStorage.find(r => r.api === api && deepEquals(r.parameters, parameters));

        return cachedValue?.response;
    };

    const setStorageItem = (key: string, value: any) => {
        setStorage((prevState) => {
            const updatedState = { ...prevState };
            updatedState[key] = value;
            return updatedState;
        });
    };

    const getStorageItem = (key: string) => {
        return storage[key];
    };

    return { cacheRequest, getCachedRequest, setStorageItem, getStorageItem };
}
